<ion-header><app-navheader></app-navheader>
	<ion-item color="primary">
		<h1 style="text-transform: uppercase; font: 400 1.8rem">les dossiers d'actualité</h1>
	</ion-item>
</ion-header>
<ion-content [ngClass]="themeClass">
	<ion-list>
	   <ion-item class="factsheetsubcategory" *ngFor="let category of categories" (click)="goToSousThemes(category)">
	   	{{ category.name }}
	   		<div class="sheet-count"><img class="sheets-icon" src="../../../assets/img/dossier-icon.png">{{category.subtheme_count}}</div>
   		<ion-icon name="fiches-arrow-right"></ion-icon>
	   </ion-item>
	</ion-list>
	<app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer>
	<app-bottom-menu [isActive] = "isActivePage"></app-bottom-menu>
</ion-footer>
<app-pop-up [show]="tempPopUp" [data]="popup" #temppopup></app-pop-up>
